import React from "react";
import {
  Box,
  FormLabel,
  Grid,
  GridItem,
  HStack,
  Checkbox,
  Text,
  Icon,
  useToast,
  Button
} from "@chakra-ui/react";
import { CheckIcon } from "@chakra-ui/icons";

const CodesSection = ({ codes, onCheckboxChange, onOpenNewCodeModal }) => {
  return (
    <div>
      <Text fontSize="lg" fontWeight="bold" mb={4}>
        کدهای اکانت
      </Text>
      <Grid templateColumns="repeat(2, 1fr)" gap={4}>
        {codes.map((code) => (
          <GridItem
            key={code.id}
            border="1px"
            borderColor="gray.200"
            borderRadius="md"
            p={3}
            bg="white"
            shadow="md"
            w="full"
            minW="160px"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <FormLabel
              htmlFor={`code-${code.id}`}
              mb={0}
              w="100px" // Adjust width as needed
              textOverflow="ellipsis"
              overflow="hidden"
              whiteSpace="nowrap"
            >
              {code.code}
            </FormLabel>
            <Checkbox
              name={code.id}
              isChecked={code.is_used}
              onChange={onCheckboxChange}
              colorScheme="green"
            >
            </Checkbox>
          </GridItem>
        ))}
      </Grid>
      <Button
        mt={4}
        colorScheme="blue"
        onClick={onOpenNewCodeModal}
        borderRadius="md"
      >
        وارد کردن کدهای جدید
      </Button>
    </div>
  );
};

export default CodesSection;
